<template>
  <div class="bg-neutral-50 border-t border-neutral-200 w-full lg:hidden fixed left-0 right-0 bottom-0 z-50">
    <nav class="sticky-navigation flex justify-between pb-9 px-4">
      <StickyNavigationMenuItem
        v-for="navItem in navigationMenuItems"
        :key="navItem.text"
        v-bind="navItem"
        class="flex-1"
        :selected="getIsSelected(navItem.to.path)"
      />
      <span class="line" :style="{ left: `${updateLine}px` }" />
    </nav>
  </div>
</template>

<script>
import StickyNavigationMenuItem from '@/components/StickyNavigation/StickyNavigationMenuItem'

export default {
  name: 'StickyNavigation',
  components: { StickyNavigationMenuItem },
  props: {
    navigationMenuItems: {
      type: Array,
      default: () => ([]),
      validator: value => value.every(obj => ['svgPrefix', 'text', 'to'].every(prop => obj.hasOwnProperty(prop)))
    }
  },
  data () {
    return {
      line: {
        itemWidth: 0,
        lineOffset: 0
      }
    }
  },
  computed: {
    updateLine () {
      return ((this.line.itemWidth - 24) / 2) + this.line.lineOffset
    }
  },
  watch: {
    $route () {
      this.$nextTick(() => {
        this.setSelected()
      })
    }
  },
  mounted () {
    this.setSelected()
    window.addEventListener('resize', this.setSelected)
  },
  destroyed () {
    window.removeEventListener('resize', this.setSelected)
  },
  methods: {
    getIsSelected (path) {
      const route = this.$route.path

      if (path === this.$i18n.localePath({ name: 'account-memberships' }) && this.$route.name?.startsWith('lang-account-memberships')) {
        return true
      }

      if (path.includes('/account/personal-details') && (this.$route.name?.startsWith('lang-account-request-personal-details') || this.$route.name?.startsWith('lang-account-personal-details-security'))) {
        return true
      }

      return route === path
    },
    setSelected () {
      if (process.client) {
        this.$nextTick(() => {
        // TODO: Find a better solution (e.g. with store)
          const className = '.set-active'
          const selected = document.querySelectorAll(className)
          let item = null
          if (selected.length > 1) {
            item = document.querySelectorAll(className)[1]
          } else {
            item = document.querySelectorAll(className)[0]
          }
          if (!item) {
            return
          }

          this.line.itemWidth = item.clientWidth
          this.line.lineOffset = item.offsetLeft
        })
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.sticky-navigation {
  max-width: 50rem;
  min-height: 11.4rem;
  padding-top: 2.8rem;
  @apply mx-auto;

  .line {
    @apply absolute h-1 w-6 bg-newBlue-400;
    margin-bottom: 2px;
    bottom: 3.2rem;
    transition: left 0.4s ease-in-out;
  }
}
</style>
